import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Input, Modal, ModalFooter, Col, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'
import Dropzone from 'react-dropzone'

import StyledInput from '../../components/Forms/Input'
import StyledSelect from '../../components/Forms/Select'
import StyledTextarea from '../../components/Forms/Textarea'
import StyledButton from '../../components/Forms/Button'

import {
  toggleModal,
  setProperty,
  setProduct,
  handleInput,
  attachFiles,
  removeAttachment,
  createNewTicket,
  setSeverity
} from '../../ducks/createInteraction'
import { showWarningFileSize } from '../../ducks/interaction'

import Preloader from '../../components/UI/Preloader'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  /* margin: 30px auto; */
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const StyledLabelValue = styled.div`
  display: flex;
  align-items: center;
  height: 42px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 11px;
  margin-top: 30px;
  padding-top: 12px;
  background-color: #fff;
  border: 1px solid ${(props) => (props.error ? '#9f2121' : '#ececf0')};
  border-radius: 2px;
  color: #727272;
  padding: 0px 10px;
`

const getColor = (props) => {
  if (props.isDragReject) {
    return '#c66'
  }
  if (props.isDragActive) {
    return '#6c6'
  }

  return '#ECECF0'
}

const StyledDragAndDrop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  border-width: 2px;
  border-radius: 5px;
  border-color: ${(props) => getColor(props)};
  border-style: ${(props) =>
    props.isDragReject || props.isDragActive ? 'solid' : 'dashed'};
  background-color: ${(props) =>
    props.isDragReject || props.isDragActive ? '#eee' : ''};

  transition: background-color 0.2s;
  :hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  cursor: pointer;
  outline: none;
`

const DragAndDropText = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #8b93a7;

  .browse {
    color: #4d7fff;
  }
`

const StyledFileList = styled.div`
  display: flex;
  flex-wrap: wrap;

  margin: 10px 0;
`

const StyledFileItem = styled.div`
  display: flex;
  align-items: center;
  color: #8b93a7;
  margin-right: 15px;

  .iconContainer {
    margin-right: 10px;
  }

  .file_name {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    font-size: 13px;
  }

  cursor: pointer;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

class CreateTicketModal extends Component {
  render() {
    const { toggleModal, interactionForm, t } = this.props
    const { isOpen } = interactionForm

    return (
      <Modal
        contentClassName="styled_modal_content"
        isOpen={isOpen}
        toggle={() => toggleModal(false)}
      >
        <StyledModalContent>
          <StyledTitle>{t('tickets:createNewTitle')}</StyledTitle>
          {this.renderBody()}
          {this.renderFooter()}
        </StyledModalContent>
      </Modal>
    )
  }

  renderBody = () => {
    const {
      interactionForm,
      properties,
      setProperty,
      setProduct,
      handleInput,
      setSeverity,
      t
    } = this.props
    const {
      selectedPropertyId,
      selectedProductId,
      products,
      title,
      body,
      severity,
      attachments,
      loading
    } = interactionForm

    return (
      <div>
        {loading && <Preloader />}
        <Row>
          <Col sm={12}>
            <StyledInput
              type="text"
              input={{
                value: title,
                name: 'title',
                id: 'ticketTitle',
                onChange: ({ target }) => handleInput('title', target.value)
              }}
              label={t('tickets:title')}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {properties.entities.length > 1 && (
              <StyledSelect
                label={t('property:name')}
                value={selectedPropertyId}
                onChangeCallback={({ target }) => setProperty(target.value)}
                options={[
                  { value: '', label: t('property:selectProperty') },
                  ...properties.entities.map(({ property_id, name }) => ({
                    value: property_id,
                    label: name
                  }))
                ]}
              >
                <option value={''}>{t('property:selectProperty')}</option>
                {properties.entities.map(({ property_id, name }) => {
                  return (
                    <option key={property_id} value={property_id}>
                      {name}
                    </option>
                  )
                })}
              </StyledSelect>
            )}
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            {products.length === 0 && (
              <StyledLabelValue error>
                {t('product:noProducts')}
              </StyledLabelValue>
            )}
            {products.length === 1 && (
              <StyledLabelValue>{products[0].name}</StyledLabelValue>
            )}
            {products.length > 1 && (
              <StyledSelect
                label={t('product:name')}
                value={selectedProductId}
                disabled={products.length === 0}
                onChangeCallback={({ target }) => setProduct(target.value)}
                options={[
                  { value: '', label: t('product:selectProduct') },
                  ...products.map(({ product_id, name }) => ({
                    value: product_id,
                    label: name
                  }))
                ]}
              >
                <option value={''}>{t('product:selectProduct')}</option>
                {products.map(({ product_id, name }) => {
                  return (
                    <option key={product_id} value={product_id}>
                      {name}
                    </option>
                  )
                })}
              </StyledSelect>
            )}
          </Col>

          <Col sm={6}>
            <StyledSelect
              label={t('severity:name')}
              value={severity}
              disabled={false}
              onChangeCallback={({ target }) => setSeverity(target.value)}
              options={[
                { value: 0, label: t('severity:0') },
                { value: 1, label: t('severity:1') },
                { value: 2, label: t('severity:2') }
              ]}
            >
              <option value={0}>{t('severity:0')}</option>
              <option value={1}>{t('severity:1')}</option>
              <option value={2}>{t('severity:2')}</option>
            </StyledSelect>
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <StyledTextarea
              type="textarea"
              input={{
                value: body,
                name: 'description',
                id: 'description',
                onChange: ({ target }) => handleInput('body', target.value)
              }}
              label={t('common:description')}
            />
          </Col>
        </Row>

        <Dropzone onDrop={this.onDrop}>
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragAccept,
            isDragReject
          }) => {
            return (
              <StyledDragAndDrop
                isDragActive={isDragActive}
                isDragReject={isDragReject}
                {...getRootProps()}
              >
                <DragAndDropText>
                  <input {...getInputProps()} />
                  {isDragAccept ? t('phrases:dnd:1') : t('phrases:dnd:0')}{' '}
                  <span className="browse">{t('phrases:dnd:2')}</span>
                </DragAndDropText>
              </StyledDragAndDrop>
            )
          }}
        </Dropzone>

        {attachments.length > 0 && (
          <StyledFileList>
            {attachments.map((file, index) => {
              return (
                <StyledFileItem
                  key={file.lastModified}
                  onClick={() => this.removeAttachmentHandler(index)}
                >
                  <div className="iconContainer">
                    <FontAwesomeIcon size="1x" icon="trash" />
                  </div>
                  <div className="file_name">{file.name}</div>
                </StyledFileItem>
              )
            })}
          </StyledFileList>
        )}
      </div>
    )
  }

  renderFooter = () => {
    const { loading } = this.props.interactionForm
    const { createNewTicket, toggleModal, t } = this.props

    return (
      <ModalFooterWrapper>
        <StyledButton
          disabled={loading}
          onClick={() => toggleModal(false)}
          outline
          bgColor="#fff"
        >
          {t('common:cancel')}
        </StyledButton>
        <StyledButton
          disabled={this.checkFormReady() || loading}
          onClick={createNewTicket}
        >
          {t('common:create')}
        </StyledButton>
      </ModalFooterWrapper>
    )
  }

  onDrop = (acceptedFiles) => {
    this.fileUploadHandler({
      preventDefault: () => {},
      target: {
        files: acceptedFiles
      }
    })
  }

  checkFormReady = () => {
    const {
      selectedPropertyId,
      selectedProductId,
      title,
      body
    } = this.props.interactionForm

    return !Boolean(selectedPropertyId && selectedProductId && title && body)
  }

  fileUploadHandler = (ev) => {
    ev.preventDefault()
    const { files } = ev.target

    const _files = []

    for (let i = 0; i < files.length; i++) {
      if (files[i].size < 134217728) {
        _files.push(files[i])
      }
    }

    this.props.attachFiles(_files)
    if (files.length > _files.length) {
      this.props.showWarningFileSize()
    }
  }

  removeAttachmentHandler = (id) => {
    this.props.removeAttachment(id)
  }
}

export default compose(
  connect(
    ({ properties, interactionForm }) => ({ properties, interactionForm }),
    {
      toggleModal,
      setProperty,
      setProduct,
      handleInput,
      attachFiles,
      removeAttachment,
      createNewTicket,
      setSeverity,
      showWarningFileSize
    }
  ),
  withNamespaces()
)(CreateTicketModal)
